document.addEventListener('DOMContentLoaded', () => {
  const input = document.querySelector('.header__search-input');
  const container = document.querySelector('[data-search-suggestions]');

  if (!input || !container) return;

  let abortController = null;

  input.addEventListener('input', () => {
    const query = input.value.trim();

    // Zu kurz? Dropdown schließen
    if (query.length < 2) {
      container.hidden = true;
      container.innerHTML = '';
      if (abortController) abortController.abort();
      return;
    }

    // laufende Anfrage abbrechen
    if (abortController) abortController.abort();
    abortController = new AbortController();

    const params = new URLSearchParams({
      q: query,
      'resources[type]': 'product,article,page',
      'resources[limit]': '4'
    });

    fetch(`/search/suggest.json?${params.toString()}`, {
      signal: abortController.signal,
      headers: { 'Accept': 'application/json' }
    })
      .then((res) => res.json())
      .then((data) => {
        const resources = data.resources || {};
        const products = resources.results?.products || [];
        const pages    = resources.results?.pages || [];
        const articles = resources.results?.articles || [];

        if (!products.length && !pages.length && !articles.length) {
          container.hidden = true;
          container.innerHTML = '';
          return;
        }

        let html = '<ul>';

        products.forEach((p) => {
          html += `<li><a href="${p.url}">${p.title}</a></li>`;
        });

        pages.forEach((p) => {
          html += `<li><a href="${p.url}">${p.title}</a></li>`;
        });

        articles.forEach((a) => {
          html += `<li><a href="${a.url}">${a.title}</a></li>`;
        });

        html += '</ul>';
        container.innerHTML = html;
        container.hidden = false;
      })
      .catch((err) => {
        if (err.name === 'AbortError') return;
        console.error('Predictive search error', err);
      });
  });

  // Beim Klick außerhalb Dropdown schließen
  document.addEventListener('click', (event) => {
    if (!container.contains(event.target) && !input.contains(event.target)) {
      container.hidden = true;
    }
  });
});
